import React from 'react'
import { PlusNumber } from '../PlusNumber'
import { Text1 } from '../Text1'
import { TableCellWithAdditionalCountProps } from './TableCellWithAdditionalCount.types'
import styles from './TableCellWithAdditionalCount.module.scss'
// import cl from 'classnames'

const TableCellWithAdditionalCountComponent = (props: TableCellWithAdditionalCountProps) => {
  const {
    text,
    title,
    additionalCount,
    totalCount = 0,
    notAvailableLabel = 'N/A'
  } = props

  const count = additionalCount || totalCount

  return (
    <>
      <Text1 overflowEllipsis title={title}>
        {text || <span className={styles.secondaryText}>{notAvailableLabel}</span>}
      </Text1>
      {count > 0 && <PlusNumber num={count} />}
    </>
  )
}

const TableCellWithAdditionalCount = TableCellWithAdditionalCountComponent
export { TableCellWithAdditionalCount }
